/**
 * @generated SignedSource<<4853faa262684ddbbe8d64313fb62ff5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UserLink_user$data = {
  readonly rowId: UUID;
  readonly " $fragmentType": "UserLink_user";
};
export type UserLink_user$key = {
  readonly " $data"?: UserLink_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"UserLink_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "UserLink_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rowId",
      "storageKey": null
    }
  ],
  "type": "GwtUser",
  "abstractKey": null
};

(node as any).hash = "b3164bd9f47a0b9b0e9ca7a2343ba51b";

export default node;
